import { useContext } from "react";
import ServiceDetailPage from "../../ones/ServiceDetailPage";
import Footer from "../../ones/Footer";
import { AppContext } from "../../App";
import { dropdownContent } from "../../data/menuDropdowns";
import image1 from "../../assets/banner3.jpg";
import image2 from "../../assets/pumas.jpg";
import image3 from "../../assets/wild_plains.jpg";

const safariRoutes = dropdownContent.safaris ?? [];

const safariPackageMeta = {
  wildlife: {
    duration: "12-17 Days | 11-16 Nights",
    travellers: "Travellers 2+",
    imagePosition: "center 36%",
  },
  migration: {
    duration: "9-10 Days | 8-9 Nights",
    travellers: "Travellers 2+",
    imagePosition: "center 48%",
  },
  beach: {
    duration: "13-15 Days | 12-14 Nights",
    travellers: "Travellers 2+",
    imagePosition: "center 38%",
  },
  rivers: {
    duration: "9 Days | 8 Nights",
    travellers: "Travellers 2+",
    imagePosition: "center 44%",
  },
};
export default function Safari() {
  const appContext = useContext(AppContext);

  function handleRouteNavigation(nav) {
    if (!nav) return;
    appContext.navTo(nav);
  }

  const safariPackages = safariRoutes.map((card) => {
    const subItem = card.nav?.subItem || "";
    const meta = safariPackageMeta[subItem] || {};

    return {
      badge: "Luxury Safari",
      title: card.title,
      description: card.text,
      duration: meta.duration || "Custom duration",
      travellers: meta.travellers || "Travellers 2+",
      image: card.img,
      imageAlt: card.title,
      imagePosition: meta.imagePosition || "center",
      nav: card.nav,
      onClick: () => handleRouteNavigation(card.nav),
      ctaLabel: "View Route",
    };
  });

  return (
    <>
      <ServiceDetailPage
        label="Safaris"
        title="Wildlife Safari"
        subtitle="Safari across Tanzania, Kenya, and Rwanda with private guiding, premium lodges, and exceptional wilderness access."
        overview="A Tanzania wildlife luxury safari combines the raw beauty of Africa's wilderness with comfort and style. Witness the Great Wildebeest Migration across the Serengeti, descend into wildlife-rich Ngorongoro Crater, and watch elephant herds in Tarangire while staying in handpicked luxury lodges and exclusive tented camps. With private game drives, personalized service, and world-class hospitality, every detail is designed to elevate your safari experience. From champagne breakfasts in the bush to sundowners above golden savannahs, each itinerary blends adventure, exclusivity, and deep connection to nature."
        images={[
          {
            src: image1,
            alt: "Luxury safari game drive",
            captionTitle: "Luxury Safari Moments",
            captionText: "Private game drives with top-tier guiding and premium positioning.",
          },
          {
            src: image2,
            alt: "Serengeti landscape",
            captionTitle: "Legendary Ecosystems",
            captionText: "Serengeti plains, crater rims, and river valleys across East Africa.",
          },
          {
            src: image3,
            alt: "Luxury tented safari camp",
            captionTitle: "Exclusive Camps & Lodges",
            captionText: "Elegant stays that keep you close to wildlife without compromise.",
          },
        ]}
        highlights={[
          "Private 4x4 game drives and expert guides across top wildlife regions.",
          "Strategic travel timing for migration, river crossing, and calving windows.",
          "Seamless logistics with luxury camp and lodge combinations.",
          "Bush breakfasts, sundowner experiences, and personalized hosting.",
        ]}
        metrics={[
          { value: "8 Packages", label: "Luxury safari options" },
          { value: "2+", label: "Travellers per trip" },
          { value: "5-17 Days", label: "Trip duration range" },
        ]}
        packageHeading="Our Tanzania Safari Packages"
        packages={safariPackages}
        ctaLabel="Design My Safari"
      />
      {safariRoutes.length > 0 && (
        <section className="MainBodySection" style={{ paddingTop: 40, paddingBottom: 60 }}>
          <div className="container">
            <div className="mx-auto text-center" style={{ maxWidth: 820 }}>
              <p className="text-uppercase" style={{ fontSize: 12, letterSpacing: 1.4, color: "#b07d2e" }}>
                EXPLORE SAFARIS
              </p>
              <h2 className="font-bold mb-2" style={{ color: "#132335", fontSize: "clamp(24px, 3vw, 32px)" }}>
                Modern safari cards aligned with the dropdown
              </h2>
              <p className="mb-0" style={{ color: "#4f5f72", lineHeight: 1.6 }}>
                Each card below mirrors the mega-dropdown entry so titles, copy, and navigation stay aligned.
              </p>
            </div>

            <div className="row g-4 mt-4">
              {safariRoutes.map((card) => (
                <div className="col-12 col-md-6 col-xl-3" key={card.title}>
                  <article
                    className="mega-card"
                    role="button"
                    tabIndex={0}
                    aria-label={`Explore ${card.title}`}
                    onClick={() => handleRouteNavigation(card.nav)}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        handleRouteNavigation(card.nav);
                      }
                    }}
                  >
                    <div className="mega-card-image" style={{ backgroundImage: `url(${card.img})` }} />
                    <div className="mega-card-overlay" />
                    <div className="mega-card-content">
                      <h6>{card.title}</h6>
                      <p>{card.text}</p>
                      <button
                        type="button"
                        className="btn btn-light btn-sm"
                        onClick={(event) => {
                          event.stopPropagation();
                          handleRouteNavigation(card.nav);
                        }}
                      >
                        View Route
                      </button>
                    </div>
                  </article>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
      <Footer />
    </>
  );
}
